import React from "react";
import "./selectInput.css";

const SelectInput = ({
  options,
  label,
  placeholder,
  required = false,
  name,
  value,
  id,
  onChange,
  disabled = false,
  multiple = false,
  multiSelect = false,
  auth = false,
  filled = false,
  bgBlue = false,
}) => {
  const handleSelect = (e) => {
    const selectedValue = e.target.value;
    if (multiSelect) {
      if (!value.includes(selectedValue)) {
        const newValue = [...value, selectedValue];
        onChange({ target: { name, value: newValue } });
      }
    } else {
      onChange({ target: { name, value: selectedValue } });
    }
  };
  const handleRemove = (val) => {
    if (!multiSelect) return;
    const newValue = value.filter((v) => v !== val);
    onChange({ target: { name, value: newValue } });
  };


  const renderSelect = () => {
    if (multiSelect) {
      return (
        <div
          className={`multi-select-container ${
            filled ? "input-filled" : auth ? "login-select" : "input-outlined"
          }`}
        >

          {/* Dropdown to add more values */}
          <select
            id={id}
            name={name}
            disabled={disabled}
            onChange={handleSelect}
            className="multi-select-dropdown"
            value=""
          >
            <option disabled hidden value="">
              {placeholder}
            </option>
            {options
              .filter((opt) => !value.includes(opt.value))
              .map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
          </select>
          {/* Chips for selected values */}
          <div className="chips-container">
            {value?.map((val) => {
              const option = options.find((opt) => opt.value === val);
              return (
                <div key={val} className="chip">
                  {option?.label || val}
                  {!disabled && (
                    <button
                      type="button"
                      className="chip-remove-btn"
                      onClick={() => handleRemove(val)}
                    >
                      &times;
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      );
    }
    return (
      <select
        id={id}
        name={name}
        value={value || ""}
        disabled={disabled}
        onChange={handleSelect}
        className={`input-style ${
          filled ? "input-filled" : auth ? "login-select" : "input-outlined"
        }`}
      >
        <option disabled hidden value="">
          {placeholder}
        </option>
        {options.map((option) => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  };

  return (
    <div className="div_label_span_select">
      <label id={id} className={!bgBlue ? "" : "label-color-grey"}>
        {label}
      </label>
      {/* {required ? (
        <span
          style={{ color: "red" }}
          className={required ? "" : "visibility-toggle"}
        >
          *
        </span>
      ) : (
        ""
      )} */}

      {renderSelect()}

      {/* <select
        id={id}
        name={name}
        value={value || ""}
        disabled={disabled}
        onChange={onChange}
        className={`input-style
          ${filled ? "input-filled" : auth ? "login-select" : "input-outlined"}
        `}
        multiple={multiple}
      >
        <option disabled hidden value="">
          {placeholder}
        </option>
        {options?.map((option, index) => (
          <option value={option.value} key={index}>
            {option.label}
          </option>
        ))}
      </select> */}
    </div>
  );
};

export default SelectInput;
